<template>
<div>
  <b-modal v-model="modalShow1" ok-only centered centered class="text-center text-info">
      Image Uploaded 
    </b-modal>
    <b-modal v-model="modalShow2" ok-only centered centered class="text-center text-info">
      Color Updated 
    </b-modal>
   <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
 <div v-if="fetch">
    <h2 class="m-auto text-info text-center pt-5 pb-4">Add a image</h2>
 
<div class="file-upload col-12 col-sm-8 col-md-6" >
  <!-- <button class="file-upload-btn" type="button" onclick="$('.file-upload-input').trigger( 'click' )" >Add Image</button> -->

  <div class="image-upload-wrap" style="height: 100px;">
    <input class="file-upload-input" type='file' @change="fileSelect1" accept=".jpg, .jpeg" />
    <div class="drag-text">
      <h6 class="pt-3">Drag and drop or select Image</h6>
    </div>
  </div>
  <div class="file-upload-content mx-auto text-center" :style="{display: visible1}">
    <img class="file-upload-image"  :src="image" alt="your image" />
    <div class=" ">
      <!-- <button type="button" @click="Upload()" class="remove-image mx-auto text-center"><span class="image-title">Upload Image</span></button> -->
      <el-button type="primary" class="mt-3 mx-auto text-center" @click="Upload()">Upload Image</el-button>
    </div>
  </div>
  <div class="mx-auto text-center">
   <el-button type="danger" class="mt-4 " @click="goback()">Go Back</el-button>
  </div>
</div>
 </div>
 <div v-if="changed">

 <h2 class="m-auto text-info text-center pt-5 pb-4">Banner Image</h2>
 <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
  <img :src="homeimg" alt="banner-image" class="bnr-img" v-if="homeimg != undefined">
  <img src="../../../static/images/banner.jpg" alt="banner-image" class="bnr-img" v-if="homeimg == undefined">
   <el-button type="primary" class="mt-3" @click="changeimg('homeimg')">Change Image</el-button>
 </div>

 <!-- <h2 class="m-auto text-info text-center pt-5 pb-4">All Categories Image</h2>
 <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
  <img :src="catimg" alt="banner-image" class="bnr-img" v-if="catimg != undefined">
  <img src="../../../static/images/banner.jpg" alt="banner-image" class="bnr-img" v-if="catimg == undefined">
   <el-button type="primary" class="mt-3" @click="changeimg('catimg')">Change Image</el-button>
 </div>

 <h2 class="m-auto text-info text-center pt-5 pb-4">Latest Offers Image</h2>
 <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
  <img :src="offerimg" alt="banner-image" class="bnr-img" v-if="offerimg != undefined">
  <img src="../../../static/images/banner.jpg" alt="banner-image" class="bnr-img" v-if="offerimg == undefined">
   <el-button type="primary" class="mt-3" @click="changeimg('offerimg')">Change Image</el-button>
 </div>

 <h2 class="m-auto text-info text-center pt-5 pb-4">App Image</h2>
 <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
  <img :src="appimg" alt="banner-image" class="bnr-img" v-if="appimg != undefined">
  <img src="../../../static/images/banner.jpg" alt="banner-image" class="bnr-img" v-if="appimg == undefined">
   <el-button type="primary" class="mt-3" @click="changeimg('appimg')">Change Image</el-button>
 </div> -->

 <h3 class="m-auto text-info text-center pt-5 pb-4">Change Text Color On Home Image</h3>
  <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
     <div>
    <ColorPicker :width="240" :height="240" :disabled="false" startColor="#ffffff" v-model="color1"></ColorPicker>
    </div>
   <el-button type="primary" class="mt-3" @click="changecolor('txtcolor')">Change Color</el-button>
 </div>

 <h3 class="m-auto text-info text-center pt-5 pb-4">Change Background Color Of Reviews Section</h3>
  <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
     <div>
    <ColorPicker :width="240" :height="240" :disabled="false" startColor="#ffffff" v-model="color1"></ColorPicker>
    </div>
   <el-button type="primary" class="mt-3" @click="changecolor2('revBackClr')">Change Color</el-button>
 </div>

 <h3 class="m-auto text-info text-center pt-5 pb-4">Change Background Color Of App Section</h3>
  <div class=" col-12 col-sm-8 col-md-6 mx-auto" >
     <div>
    <ColorPicker :width="240" :height="240" :disabled="false" startColor="#ffffff" v-model="color1"></ColorPicker>
    </div>
   <el-button type="primary" class="mt-3" @click="changecolor3('appBackClr')">Change Color</el-button>
 </div>

 </div>
 <!-- <h2 class="m-auto text-info text-center pt-5 pb-4">Add a logo image</h2>
 
<div class="file-upload">
  

  <div class="image-upload-wrap" style="height: 120px;">
    <input class="file-upload-input" type='file' multiple max="4" @change="readLogo" accept=".jpg, .jpeg, .png" />
    <div class="drag-text">
      <h3 class="pt-4">Drag and drop a file or select add Image</h3>
    </div>
  </div>
  <div class="row  ">
  <div v-for="(file , i) in imgfiles" :key="i" class="file-upload-content justify-item-center col-12 col-sm-6 col-md-3" :style="{display: visible1}">
    <div :style="{display: visible1}">
    <img class="file-upload-image" style="margin-right:0px;" :src="file" alt="your image" />
    <div class="image-title-wrap mt-2">
      <button type="button" @click="removeimg(i)" class="remove-image"><span class="image-title">Remove Image</span></button>
    </div>
    </div>
  </div>
  </div>
</div> -->
</div>
</template>

<script>
import ImageCompressor from 'image-compressor.js';
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
import ColorPicker from 'vue-color-picker-wheel';
export default {
  name: 'adminhome',
  components: {
    ColorPicker
  },
  data() {
      return {
          image: "",
          logoimg:'',
          modalShow1:false,
           modalShow2:false,
        dialogImageUrl: '',
        dialogVisible: false,
        visible: 'block',
        visible1: 'none',
        shops: [],
        imgfiles:[],
        otherimgs:[],
        maxFiles: 4,
        loading:false,
         loading1:false,
        fetch:false,
        changed:true,
        homeimg:'',
        catimg:'',
        offerimg:'',
        appimg:'',
        color1:'#409EFF',
        imgUpObj:{ },
        imgtype:''
      };
    },
    methods: {
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      
    fileSelect1(event) {
      console.log('event is', event)
      const files = event.target.files;
      let filename = files[0].name;
      if(files[0].type == 'image/png' || files[0].type == 'image/gif' || files[0].type == 'image/svg+xml' || files[0].type == 'image/tiff'){
       alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      }else if(files[0].size > 5000200){
       alert("File " + files[0].name + " is too large! maximum file size should be 5MB");
      }else{
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.visible = 'none'
        this.image = reader.result;
         this.visible1 = 'block'
      });
      reader.readAsDataURL(files[0]);
     //this.image = files[0];
     const imageCompressor = new ImageCompressor();
      imageCompressor.compress(files[0], {quality: .6, width:720, height:720})
      .then((result) => {
        // Handle the compressed image file.
        if(result.size > 300000){
          const imageCompressor = new ImageCompressor();
          imageCompressor.compress(result, {quality: .4})
          .then((result) => {
         
          const fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener('load', () => {
               
               this.image1 = fileReader.result
              
               console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);
          
          //console.log(filename) 
          console.log(result.size)
           console.log('image is',result)
      })
        }else{
           
          var fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
               
               this.image1 = fileReader.result
              
               console.log('else image is',this.image1)
          });
          fileReader.readAsDataURL(result);
          //console.log(filename) 
          console.log('else',result.size)
           console.log('ekse image is',result)
        }
      })
      
      .catch((err) => {
        // Handle the error
        console.log("error is" + err)
      })
      }
    },
      
  //  readLogo(event) {
       
  //         var files = event.target.files;
  //         console.log('files are', files)
  //          console.log('imgfiles.length are', this.imgfiles.length)
  //   if(files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length+this.imgfiles.length > this.maxFiles){
  //      alert("You can only upload a maximum of " + this.maxFiles + " files")
  //      return 0;
  //   }else{
  //    for(var i=0; i < files.length; i++){
  //     if(files[i].size > 5000200){
  //      alert("File " + files[i].name + "is too large!");
  //     }else{

  //   var reader = new FileReader();

  //   reader.addEventListener("load", () => {
  //   //   document.getElementsByClassName('image-upload-wrap').hide();
  //       this.visible = 'none'
  //       // this.logoimg = reader.result
  //       this.visible1 = 'inline'
   
  //   });
  //   reader.readAsDataURL(files[i]);
  //   console.log('files[0]', files[i])
  //   const imageCompressor = new ImageCompressor();
  //     imageCompressor.compress(files[i], {quality: .6, width:720, height:1340 })
  //     .then((result) => {
  //       // Handle the compressed image file.
  //       if(result.size >= 1000000){
  //         const imageCompressor = new ImageCompressor();
  //         imageCompressor.compress(result, {quality: .5})
  //         .then((result) => {
  //          const fileReader = new FileReader();

  //             // This fires after the blob has been read/loaded.
  //             fileReader.addEventListener('load', () => {
  //               this.imgfiles.push(fileReader.result)
  //              var otherimg = fileReader.result
  //              this.otherimgs.push(otherimg)
  //              console.log('image is',this.otherimgs)
  //             });

  //             // Start reading the blob as text.
  //             fileReader.readAsDataURL(result);
          
  //         //console.log(filename) 
  //         console.log(result.size)
  //          console.log('image is',result)
           
  //     })
  //       }else{
  //         //  const reader = new FileReader();

  //         //     // This fires after the blob has been read/loaded.
  //         //     reader.addEventListener('loadend', (e) => {
  //         //       this.image2 = e.srcElement.result;
  //         //      console.log('else image is',this.image2)
  //         //     });

  //         //     // Start reading the blob as text.
  //         //     reader.readAsText(result);
  //         var fileReader = new FileReader();
  //         fileReader.addEventListener('load', () => {
  //               this.imgfiles.push(fileReader.result)
  //              var otherimg = fileReader.result
  //              this.otherimgs.push(otherimg)
  //              console.log('else image is',this.otherimgs)
  //         });
  //         fileReader.readAsDataURL(result);
  //         //console.log(filename) 
  //         console.log('else',result.size)
  //          console.log('ekse image is',result)
  //       }
  //     })
      
  //     .catch((err) => {
  //       // Handle the error
  //       console.log("error is" + err)
  //     })
  //   }
  //   }
  //   }
  // },  

 Upload() {
          console.log('image added')
          this.loading = true
          this.fetch =false
          this.imgUpObj[this.imgtype] = this.image1
          db.collection('shops').doc(this.shops[0].id)
          .update(this.imgUpObj)
          .then(() => {
            this.loading = false
            this.changed = true
             //this.modalShow1 = true
          })
    },
     onColorChange(color) {
      console.log('Color has changed to: ', color);
      this.color1 = color
    },
  changecolor(){
      db.collection('shops').doc(this.shops[0].id)
      .update({ txtcolor: this.color1 })
      .then(() => {
        this.modalShow2 = true
      })
  },
  changecolor2(){
      db.collection('shops').doc(this.shops[0].id)
      .update({ revBackClr: this.color1 })
      .then(() => {
        this.modalShow2 = true
      })
  },
  changecolor3(){
      db.collection('shops').doc(this.shops[0].id)
      .update({ appBackClr: this.color1 })
      .then(() => {
        this.modalShow2 = true
      })
  },
  changeimg(imgtype){
    this.changed = false
    this.fetch = true
    var newObj = {}
    this.imgUpObj = newObj
    this.imgtype = imgtype
    this.imgUpObj[imgtype] = ''
  },
  goback(){
     this.changed = true
    this.fetch = false
  },
  removeimg(i) {
       if (i > -1) {
        this.otherimgs.splice(i, 1)
        this.imgfiles.splice(i, 1)
      }
      console.log('img files is', this.imgfiles) 
      console.log('otherimg is', this.otherimgs) 
  },
   backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
},

 created() {
   this.backToTop()
   this.loading1 = true
   this.changed =false
      db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).onSnapshot(querySnapshot => {
        this.shops = []
      querySnapshot.forEach(doc => {
        const data = {
          'shoptype' : doc.data().shoptype,
          'id' : doc.id,
          'homeimg':doc.data().homeimg,
          'catimg':doc.data().catimg,
          'offerimg':doc.data().offerimg,
          'appimg':doc.data().appimg
          
        }
        this.shops.push(data)
        this.homeimg = this.shops[0].homeimg
        this.catimg = this.shops[0].catimg
        this.offerimg = this.shops[0].offerimg
        this.appimg = this.shops[0].appimg
        this.loading1 = false
        this.changed = true
          console.log(this.shops[0].id)
      })
    })
  },
   
}
</script>

<style scoped>
 @import url('~@/assets/admin/css/imgupload.css');
@import url('~@/assets/admin/css/admin-loader.css');
.bnr-img{
  width:400px;
  height: 270px;
}
@media (max-width: 575px){
  .bnr-img{
  width:250px;
  height: 165px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/admin/AdminHome.vue